export default __webpack_public_path__ + "static/media/inbox.a4446cba.svg";